import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=6ca774c4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=6ca774c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca774c4",
  null
  
)

export default component.exports